import ReqClient from './request.class'

// 转化-批量检查
export async function checkBatch(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/checkBatch',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 转化-账号批量检查可用
export async function checkBatchConverter(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/getConvertList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取优化目标列表及校验
export async function getGoalsList(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/getGoalsList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取优化目标列表及校验2.0
export async function getJuLiangPlusGoalsList(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/getJuLiangPlusGoalsList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 建转化追踪
export async function autoCreateConvert(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/addConvert',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建今日头条批量3.0任务
export async function addToutiaoBatchTask(data) {
  const Req = new ReqClient({
    // url: '/api/ptom/ptomBatch/addToutiaoBatchTask', // 2.0
    url: '/api/ptom/ptomBatch/addToutiaoBatchTaskNew',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建今日头条批量2.0任务（废弃）
export async function addToutiaoBatchTaskSecond(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addNewToutiao2BatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建今日头条批量2.0任务_20260207更新
export async function submitNewToutiaoBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addTtv3BatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建巨擘3.0标准项目批量任务
export async function submitToutiaoJubaoBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addTtJubaoBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据广告账号获取不限预算广告组
export async function queryGroupByAccountWithBudget(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adGroup/querybyAccountWithBudget',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加广告组-批量
export async function addCampaignBatch(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/campaign/batchAdd',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function findPlanTaskById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/findPlanTaskById',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改提交任务
export async function updatePlanTaskById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateAdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// /api/ptom/ptomBatch/updateToutiao2AdPlan已废弃
// 修改提交任务 头条2.0 20260207修改
export async function updatePlanTaskByIdNew(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateTtv3AdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传图文 头条2.0
export async function addCarousel(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/carouselCreate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取图文列表 头条2.0
export async function getCarouselList(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/carouselList',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据id获取图文 头条2.0
export async function getCarouselsById(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/carouselListByIds',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 星广联投任务列表
export async function getStarDeliveryTaskList(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/starDelivery/task/detail',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取蓝海流量列表
 * @param {*} data
 * @return {*}
 */
export async function getBlueFlowPackageList(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getBlueFlowPackage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取广告分类、品牌
 * @param {*} data
 * @return {*}
 */
export async function getBrandCategoryInfo(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getCategoryAndBrand',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取账户可投品牌列表（智擎版）
 * @param {*} data
 * @return {*}
 */
export async function getBrandList(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getBrandList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取蓝海流量关键词
 * @param {*} data
 * @return {*}
 */
export async function getBlueFlowKeywords(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getBlueKeywords',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
